/* eslint-disable import/prefer-default-export */
export const getStatus = state => state.confirmDialog.status
export const getMessage = state => state.confirmDialog.message
